import { ContentfulModel } from './ContentfulModel';
import { Article } from './Article';

export class Articles extends ContentfulModel {
    private articleIds: string[];

    parseContentfulData(object: any): void {
        this.articleIds = object.articles?.map(x => x.sys.id) ?? [];
    }

    getArticles(): Article[] {
        return this.articleIds.map(x => this.getById(x) as Article);
    }

    getType(): string {
        return 'articles';
    }
};
